/**
 * カスタマイズ設定検索
 * @param {object[]} prevList フィルタ対象のカスタマイズリスト
 * @param {string} selectedYear 年
 * @param {string} selectedMonth 月
 * @param {string} comment コメント
 */
export const searchCustomizeHistories = (prevList, selectedYear, selectedMonth, comment) => {
  let results = prevList;

  // 登録日（年）
  const year = Number(selectedYear);
  if (!isNaN(year) && year !== '') {
    results = results.filter(item => new Date(item.registered_at).getFullYear() === year);
  }
  // 登録日（月）
  const month = Number(selectedMonth);
  if (!isNaN(month) && month !== '') {
    results = results.filter(item => new Date(item.registered_at).getMonth() + 1 === month);
  }
  // 説明
  if (comment !== '') {
    results = results.filter(item => item.description && item.description.indexOf(comment) !== -1);
  }

  return results;
};

// 検索条件
const SEARCH_YEAR_RANGE = 10;
const SEARCH_MONTH_RANGE = 12;
/**
 * 初期の検索条件の設定（現在の年、月）を取得
 * @returns { { selectedYear: string; searchYearOptions: string[]; selectedMonth: string; searchMonthOptions: string[]; }} 初期検索条件
 */
export const getInitializeSearchConditions = () => {
  const conditions = {};
  // 初期の検索条件の設定（現在の年、月）
  const currentYear = new Date().getFullYear();
  conditions.selectedYear = String(currentYear);
  // 空白(全年検索用)+今年+過去10年を選択できるような選択肢配列を作成
  conditions.searchYearOptions = [''].concat([...Array(SEARCH_YEAR_RANGE + 1)].map((_, i) => String(currentYear - i)));
  const currentMonth = new Date().getMonth() + 1;
  conditions.selectedMonth = String(currentMonth);
  // 空白(全月検索用)+1月-12月を選択できるような選択肢配列を作成
  conditions.searchMonthOptions = [''].concat([...Array(SEARCH_MONTH_RANGE)].map((_, i) => String(i + 1)));
  return conditions;
};

export default {
  searchCustomizeHistories,
  getInitializeSearchConditions,
};